import { render } from "./HowWeCanHelp.vue?vue&type=template&id=423d036e&scoped=true"
import script from "./HowWeCanHelp.vue?vue&type=script&lang=js"
export * from "./HowWeCanHelp.vue?vue&type=script&lang=js"

import "./HowWeCanHelp.vue?vue&type=style&index=0&id=423d036e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423d036e"]])

export default __exports__